/*
 * Posts the retinol email captures to Klaviyo. Two calls, both client-side
 * endpoints taking the public key only — a private key must never appear here.
 *
 *   1. POST /client/subscriptions  -> adds them to the list (consent recorded)
 *   2. POST /client/events         -> fires the "Requested Retinol Report" metric
 *
 *   Content-Type: application/vnd.api+json, revision: 2026-07-15, -> 202
 *
 * Two calls because the list and the trigger want to be different things.
 * The list is the main Skincare audience, so signups join the newsletter like
 * anyone else. But Skincare has 76k members fed by the footer form and other
 * sources, so it is useless as a flow trigger — "Retinol Signup Follow Up"
 * would fire for all of them. The event is the distinction: it only ever
 * happens when someone submits one of these captures, and it carries which
 * placement they used.
 *
 * So: flow triggers on the METRIC, not on list membership.
 *
 * The event is fire-and-forget. If it fails the subscription still stands, and
 * the person is on the list — better to lose the follow-up than the address.
 *
 * The list is read per-form from data-list-id (Settings -> Klaviyo).
 */
(function () {
  var COMPANY_ID = 'T2cba4';
  var SUBSCRIBE_ENDPOINT = 'https://a.klaviyo.com/client/subscriptions?company_id=' + COMPANY_ID;
  var EVENT_ENDPOINT = 'https://a.klaviyo.com/client/events?company_id=' + COMPANY_ID;
  var REVISION = '2026-07-15';
  var METRIC = 'Requested Retinol Report';

  if (window.__rjKlaviyoSubscribeBound) return;
  window.__rjKlaviyoSubscribeBound = true;

  function show(el, message, isError) {
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
    el.classList.toggle('klaviyo-subscribe__status--error', !!isError);
  }

  function subscribe(form) {
    var input = form.querySelector('input[type="email"]');
    var button = form.querySelector('button[type="submit"]');
    var status = form.querySelector('.klaviyo-subscribe__status');
    var success = form.querySelector('.klaviyo-subscribe__success');
    var listId = form.getAttribute('data-list-id');
    var email = input ? input.value.trim() : '';

    if (!email || !input.checkValidity()) {
      show(status, 'Please enter a valid email address.', true);
      if (input) input.focus();
      return;
    }
    if (!listId) return;

    form.setAttribute('aria-busy', 'true');
    if (button) button.disabled = true;
    show(status, '', false);
    status.hidden = true;

    fetch(SUBSCRIBE_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/vnd.api+json',
        revision: REVISION
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: form.getAttribute('data-source') || 'Retinol Report',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: listId } } }
        }
      })
    })
      .then(function (response) {
        if (response.status !== 202) throw new Error('Klaviyo responded ' + response.status);

        // Fire-and-forget: this is what the follow-up flow triggers on.
        fetch(EVENT_ENDPOINT, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/vnd.api+json',
            revision: REVISION
          },
          body: JSON.stringify({
            data: {
              type: 'event',
              attributes: {
                properties: {
                  source: form.getAttribute('data-source') || '',
                  page: window.location.pathname
                },
                metric: { data: { type: 'metric', attributes: { name: METRIC } } },
                profile: { data: { type: 'profile', attributes: { email: email } } }
              }
            }
          })
        }).catch(function (error) {
          if (window.console) console.error('[klaviyo-subscribe] event', error);
        });

        // Let Klaviyo's onsite script attach the email to this browser's
        // profile, so later on-site activity is attributed to the same person.
        if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
          try { window.klaviyo.identify({ email: email }); } catch (e) {}
        }

        // Confirm clearly (client, 2026-09-28: people couldn't tell their email was accepted):
        // the field empties so it visibly "took" the address, and the success line shows in
        // dark red with a check (styles in retinol-report.css). The field stays usable, so a
        // second address can be entered. (The row used to be hidden here, but `display:flex`
        // on .rg-form__row overrode [hidden], so the typed email just sat in the box.)
        if (input) {
          input.value = '';
          input.blur();
        }
        if (status) status.hidden = true;
        if (success) show(success, success.getAttribute('data-success-message') || 'Thanks — check your inbox.', false);
      })
      .catch(function (error) {
        show(status, 'Something went wrong. Please try again.', true);
        if (window.console) console.error('[klaviyo-subscribe]', error);
      })
      .then(function () {
        form.removeAttribute('aria-busy');
        if (button) button.disabled = false;
      });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof Element) || !form.hasAttribute('data-klaviyo-subscribe')) return;
    event.preventDefault();
    subscribe(form);
  });
})();
